import { securedAxiosInstance } from "../axios";
import { toSnakeCase } from "@estaly/ui";

class RetributionsService {
  fetchAnalytics(params) {
    return securedAxiosInstance.get("/retributions/analytics", { params: toSnakeCase(params) });
  }

  fetchIndex(params) {
    return securedAxiosInstance.get("/retributions", { params: toSnakeCase(params) });
  }

  export(params) {
    return securedAxiosInstance.post("/retributions/export", toSnakeCase(params), { responseType: "blob" });
  }
}

export default new RetributionsService();
